import { BnumConfig } from '../BnumConfig';

const TAG_PREFIX = BnumConfig.Get('tag_prefix')! as 'bnum';

export const TAG_ICON = `${TAG_PREFIX}-icon` as const;
export const TAG_BUTTON = `${TAG_PREFIX}-button` as const;
export const TAG_PRIMARY = `${TAG_PREFIX}-primary-button` as const;
export const TAG_SECONDARY = `${TAG_PREFIX}-secondary-button` as const;
export const TAG_TERTIARY = `${TAG_PREFIX}-tertiary-button` as const;
export const TAG_DANGER = `${TAG_PREFIX}-danger-button` as const;
export const TAG_TOGGLE_BUTTON = `${TAG_PREFIX}-toggle-button` as const;
export const TAG_HELPER = `${TAG_PREFIX}-helper` as const;
export const TAG_PICTURE = `${TAG_PREFIX}-img` as const;
export const TAG_CARD_TITLE = `${TAG_PREFIX}-card-title` as const;
export const TAG_CARD = `${TAG_PREFIX}-card` as const;
export const TAG_CARD_EMAIL = `${TAG_PREFIX}-card-email` as const;
export const TAG_CARD_AGENDA = `${TAG_PREFIX}-card-agenda` as const;
export const TAG_CARD_ITEM = `${TAG_PREFIX}-card-item` as const;
export const TAG_CARD_ITEM_MAIL = `${TAG_PREFIX}-card-item-mail` as const;
export const TAG_CARD_ITEM_AGENDA = `${TAG_PREFIX}-card-item-agenda` as const;
export const TAG_CARD_LIST = `${TAG_PREFIX}-card-list` as const;
export const TAG_DATE = `${TAG_PREFIX}-date` as const;
export const TAG_ICON_BUTTON = `${TAG_PREFIX}-icon-button` as const;
export const TAG_COLUMN = `${TAG_PREFIX}-column` as const;
export const TAG_INPUT = `${TAG_PREFIX}-input` as const;
export const TAG_INPUT_DATE = `${TAG_INPUT}-date` as const;
export const TAG_INPUT_NUMBER = `${TAG_INPUT}-number` as const;
export const TAG_INPUT_SEARCH = `${TAG_INPUT}-search` as const;
export const TAG_INPUT_TEXT = `${TAG_INPUT}-text` as const;
export const TAG_INPUT_TIME = `${TAG_INPUT}-time` as const;
export const TAG_FOLDER = `${TAG_PREFIX}-folder` as const;
export const TAG_HIDE = `${TAG_PREFIX}-hide` as const;
export const TAG_FOLDER_LIST = `${TAG_PREFIX}-folder-list` as const;
export const TAG_HEADER = `${TAG_PREFIX}-header` as const;
export const TAG_SEGMENTED_ITEM = `${TAG_PREFIX}-segmented-item` as const;
export const TAG_SEGMENTED_CONTROL = `${TAG_PREFIX}-segmented-control` as const;
export const TAG_SELECT = `${TAG_PREFIX}-select` as const;
export const TAG_BADGE = `${TAG_PREFIX}-badge` as const;
export const TAG_FRAGMENT = `${TAG_PREFIX}-fragment` as const;
export const TAG_RADIO = `${TAG_PREFIX}-radio` as const;
export const TAG_RADIO_GROUP = `${TAG_PREFIX}-radio-group` as const;
export const TAG_TREE = `${TAG_PREFIX}-tree` as const;
